import { useState } from "react";
import menuoption from '@features/projects/assets/menupoints.png';
import addoption from '@features/projects/assets/addcircle.png'
import detailProjectStyles from "@features/projects/styles/detailproject.module.scss";
import { AddTask } from "../../Task/AddTask";
import { IFormData } from "@/api/tasks/types";
import { ISection } from "@/api/projects/types";
import { useDispatch } from "react-redux";
import { useI18n } from "@/features/i18n/useI18n";
import { showCreateUpdateSection } from "@/features/projects/slices/projectsSlice";

interface IOptionBoardProps {
  sectionData: ISection;
  newTask: (form: IFormData) => void;
  activeId: { id: number; active: boolean };
  handleClick: (id: number) => void;
  handleCancel: (id: number, state: boolean) => void;
  // handlerDelete: (id: number) => void;
}

export const BoardColumn = ({
  sectionData,
  newTask,
  activeId,
  handleClick,
  handleCancel,
  // handlerDelete,
}: IOptionBoardProps) => {
  const [task, setTask] = useState(false);
  const { name: title, id: sectionId, description } = sectionData;
  const dispatch = useDispatch();
  const { t } = useI18n();

  const addNewTask = (form: IFormData) => {
    if (form.title && form.title.length > 0) {
      newTask(form);
      setTask(!task);
    }
  };

  const closeAddTask = () => {
    setTask(!task);
  }

  return (
    <div className={detailProjectStyles["board__column-header"]}>
      <p className={detailProjectStyles["board__column-title"]}>{title}</p>
      <div className={detailProjectStyles["optionDetails__options"]}>
        <button
          type="button"
          onClick={() => setTask(!task)}
          tabIndex={0}
          aria-label="Add task"
          className={detailProjectStyles["board__column-addBtn"]}
        >
          <img
            className={detailProjectStyles["optionboard__add"]}
            src={addoption}
            width={32} height={32}
            alt="addoption"
          />
        </button>
        <div className={detailProjectStyles["board__column-options"]} >
          <button onClick={() => handleClick(sectionId)} tabIndex={0}>
            <img src={menuoption} width={4} height={20} alt="menuoption" />
          </button>
          {
            activeId?.id === sectionId && activeId?.active === true &&
            <div className={detailProjectStyles["optionboard__options_crud"]}>
              {/* <button className={detailProjectStyles["optionboard__options_crud_delete"]}
                  onClick={() => handlerDelete(sectionId)}
                >
                  {t("module_projects.section_options_delete")}
                </button> */}
              <button className={detailProjectStyles["optionboard__options_crud_cancel"]}
                onClick={() => handleCancel(0, false)}
              >
                {t("module_projects.section_options_cancel")}
              </button>
              <button className={detailProjectStyles["optionboard__options_crud_cancel"]}
                onClick={() => {
                  dispatch(showCreateUpdateSection({ id: sectionId, title, description }));
                  handleCancel(0, false);
                }}
              >
                {t("module_projects.section_options_update")}
              </button>
            </div>
          }
        </div>
      </div>
      {task ? <AddTask addNewTask={addNewTask} closeAddTask={closeAddTask} sectionId={sectionId.toString()} /> : null}
    </div >
  );
};
